export function showModal(title: string, content: HTMLElement, opts?: { wide?: boolean }): { el: HTMLElement; close: () => void } {
  const backdrop = document.createElement('div');
  backdrop.className = 'fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4';

  const modal = document.createElement('div');
  modal.className = `bg-card rounded-xl shadow-xl border border-gray-200 w-full ${opts?.wide ? 'max-w-3xl' : 'max-w-lg'} max-h-[90vh] flex flex-col transform transition-all duration-200 scale-95 opacity-0`;

  const header = document.createElement('div');
  header.className = 'flex items-center justify-between px-6 py-4 border-b border-gray-200';
  header.innerHTML = `
    <h3 class="text-lg font-semibold text-gray-900">${title}</h3>
    <button class="modal-close p-1 rounded hover:bg-gray-100"><svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg></button>
  `;

  const body = document.createElement('div');
  body.className = 'px-6 py-4 overflow-y-auto flex-1';
  body.appendChild(content);

  modal.appendChild(header);
  modal.appendChild(body);
  backdrop.appendChild(modal);
  document.body.appendChild(backdrop);

  requestAnimationFrame(() => {
    modal.classList.remove('scale-95', 'opacity-0');
    modal.classList.add('scale-100', 'opacity-100');
  });

  const close = () => {
    modal.classList.add('scale-95', 'opacity-0');
    setTimeout(() => backdrop.remove(), 200);
  };

  header.querySelector('.modal-close')!.addEventListener('click', close);
  backdrop.addEventListener('click', (e) => {
    if (e.target === backdrop) close();
  });

  return { el: backdrop, close };
}

export function confirmModal(message: string): Promise<boolean> {
  return new Promise(resolve => {
    const content = document.createElement('div');
    content.innerHTML = `
      <p class="text-gray-700 mb-6">${message}</p>
      <div class="flex justify-end gap-3">
        <button class="btn-outline cancel-btn">Cancel</button>
        <button class="btn-danger confirm-btn">Confirm</button>
      </div>
    `;

    const { close } = showModal('Confirm', content);
    content.querySelector('.cancel-btn')!.addEventListener('click', () => { close(); resolve(false); });
    content.querySelector('.confirm-btn')!.addEventListener('click', () => { close(); resolve(true); });
  });
}
